export type AppConfig = {
  API: string
  AUTHORITY: string
  CLIENT: string
  MUI_LICENSE_KEY: string
  APP_NAME: string
  APP_VERSION: string
  OTEL_APM_TOKEN: string
  OTEL_APM: string
  TELEMETRY_ENABLED: string
  // Optional variables
  DEBUG_RULE_ENGINE?: string
}

export function validateConfig(raw: unknown): AppConfig {
  const errors: string[] = []

  const obj = (raw ?? {}) as Record<string, unknown>

  // API
  if (typeof obj.API !== 'string') {
    errors.push('API must be a string')
  } else {
    try {
      // basic URL validation
      const u = new URL(obj.API)
      if (!/^https?:$/.test(u.protocol)) {
        errors.push('API must use http or https')
      }
    } catch {
      errors.push('API must be a valid URL')
    }
  }

  // AUTHORITY
  if (typeof obj.AUTHORITY !== 'string') {
    errors.push('AUTHORITY must be a string')
  } else {
    try {
      // basic URL validation
      const u = new URL(obj.AUTHORITY)
      if (!/^https?:$/.test(u.protocol)) {
        errors.push('AUTHORITY must use http or https')
      }
    } catch {
      errors.push('AUTHORITY must be a valid URL')
    }
  }

  // CLIENT
  if (typeof obj.CLIENT !== 'string') {
    errors.push('CLIENT must be a string')
  } else {
    try {
      // basic URL validation
      const u = new URL(obj.CLIENT)
      if (!/^https?:$/.test(u.protocol)) {
        errors.push('CLIENT must use http or https')
      }
    } catch {
      errors.push('CLIENT must be a valid URL')
    }
  }

  // APP_NAME
  if (typeof obj.APP_NAME !== 'string' || obj.APP_NAME.trim() === '') {
    errors.push('APP_NAME must be a non-empty string')
  }

  // APP_VERSION
  if (typeof obj.APP_VERSION !== 'string' || obj.APP_VERSION.trim() === '') {
    errors.push('APP_VERSION must be a non-empty string')
  }

  // OTEL_APM
  if (typeof obj.OTEL_APM !== 'string') {
    errors.push('OTEL_APM must be a string')
  } else if (obj.OTEL_APM.trim() !== '') {
    try {
      // basic URL validation (allow empty for optional telemetry)
      const u = new URL(obj.OTEL_APM)
      if (!/^https?:$/.test(u.protocol)) {
        errors.push('OTEL_APM must use http or https')
      }
    } catch {
      errors.push('OTEL_APM must be a valid URL or empty string')
    }
  }

  // OTEL_APM_TOKEN
  if (typeof obj.OTEL_APM_TOKEN !== 'string') {
    errors.push('OTEL_APM_TOKEN must be a string')
  }

  // TELEMETRY_ENABLED
  if (typeof obj.TELEMETRY_ENABLED !== 'string') {
    errors.push('TELEMETRY_ENABLED must be a string')
  } else if (!['true', 'false'].includes(obj.TELEMETRY_ENABLED.toLowerCase())) {
    errors.push('TELEMETRY_ENABLED must be "true" or "false" (string)')
  }

  // MUI_LICENSE_KEY
  if (typeof obj.MUI_LICENSE_KEY !== 'string') {
    errors.push('MUI_LICENSE_KEY must be a string')
  }

  if (errors.length) {
    throw new Error(`Invalid runtime config: ${errors.join('; ')}`)
  }

  const cfg: AppConfig = {
    API: obj.API as string,
    AUTHORITY: obj.AUTHORITY as string,
    CLIENT: obj.CLIENT as string,
    APP_NAME: obj.APP_NAME as string,
    APP_VERSION: obj.APP_VERSION as string,
    OTEL_APM: obj.OTEL_APM as string,
    OTEL_APM_TOKEN: obj.OTEL_APM_TOKEN as string,
    TELEMETRY_ENABLED: obj.TELEMETRY_ENABLED as string,
    MUI_LICENSE_KEY: obj.MUI_LICENSE_KEY as string,
  }

  return Object.freeze(cfg)
}
